import React from "react";

const TextArea = ({ id, label, register, validationSchema, ...inputProps }) => {
	return (
		<>
			<label
				htmlFor={id}
				className="block mb-2 text-sm font-medium text-gray-900">
				{label}
			</label>
			<textarea
				id={id}
				className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500"
				{...register(id, validationSchema)}
				{...inputProps}></textarea>
		</>
	);
};

export default TextArea;
